import { MgState, SubmissionEnvironmentState } from '@types';
import { createSelector } from 'reselect';

export const submissionEnvironmentSelector = (store: MgState): SubmissionEnvironmentState =>
  store?.submissionEnvironment;

export const submissionEnvironmentAttachmentsSelector = createSelector(
  [submissionEnvironmentSelector],
  (env) => env.attachments
);
